import UploadFile from './UploadFile'
import UploadQiniu from './UploadQiniu'
import UploadVideo from './UploadVideo'
import SelectFile from './SelectFile';

export { UploadFile,UploadQiniu,UploadVideo,SelectFile }


// WEBPACK FOOTER //
// ./src/components/Upload/index.js